module.exports = __webpack_public_path__ + "cut_reward_icon.webp";